export const BOX_SIZE_BREAKPOINT = {
  THRESHOLD_FOR_MEDIUM: 6,
  THRESHOLD_FOR_LARGE: 10,
};
export const N_A = 'N/A';
